import { Component, Input, OnInit } from "@angular/core";

import { ViewCell } from "ng2-smart-table";
import { STATUS } from "../../@core/data/default-list";

@Component({
  template: `<strong [ngClass]="renderCss" style="text-align: left;">
    {{ renderValue }}
  </strong>`,
})
export class StbCustomRenderStatusEditorComponent implements ViewCell, OnInit {
  renderValue: string;
  renderCss: string;
  statusList = STATUS;

  @Input() value: number;
  @Input() rowData: any;

  ngOnInit() {
    this.renderValue =
      this.value === 1
        ? "Xuất bản"
        : this.value === -1
        ? "Ẩn nội dung"
        : "Đang thực hiện";

    this.renderCss =
      this.value === 1
        ? "text-success"
        : this.value === -1
        ? "text-warning"
        : "text-info";
  }
}
